__turbopack_context__.v({
  "wrapper": "ContentsLinks-module__OY2AfG__wrapper",
});
